export class EditResult {
    constructor(public success: boolean, public recordName?: string) { }
};
